import state from './state'

export default {
    getTransmissionTypes: () => state.transmissions || [],
    getTypes: () => state.types || [],
    getClasses: () => state.classes || []
}